<div [hidden]="showRequest">



  <h2 *ngIf="!IsAdminMode" class="sectionTitle">{{'FRONT_USER.TRANSIT_REQUEST_FORM.FORM' | translate }}
  </h2>

  <div *ngIf="transitRequestId">
    <!--request Details summary-->
    <app-request-details [baseRequest]="baseRequestDTO"></app-request-details>
  </div>


  <div class="bs-callout bs-callout-info">
    <h4>{{'FRONT_USER.TRANSIT_REQUEST_FORM.FEES_RELATED_REQUEST' | translate}}</h4>
    <p>{{'FRONT_USER.TRANSIT_REQUEST_FORM.FEES_RELATED' | translate}} <a
        (click)="getFeesByTransitId()">{{FeesRequestNumber}}</a></p>
  </div>
  <div
    *ngIf="showActionButtons && formMode!=FormMode.Add && !loggedInUser?.IsAdmin && ShowTakeActions && !baseRequestDTO?.IsExpired"
    class="form-container">
    <h4 class="section-title">
      {{ 'FRONT_USER.ACTION_TO_BE_TAKEN' | translate }}
    </h4>
    <div ngbDropdown class="dropdown">
      <button ngbDropdownToggle id="request-action-menu" type="button" aria-haspopup="true" aria-expanded="false">
        {{ 'FRONT_USER.TAKE_ACTION' | translate }}
        <span class="caret"></span>
      </button>
      <ul ngbDropdownMenu class="dropdown-menu" aria-labelledby="request-action-menu">
        <li>
          <!-- *ngIf="formMode!=FormMode.Add && !loggedInUser?.IsAdmin && !baseRequestDTO.IsExpired && baseRequestDTO.IsCompleted && validFees && hasTransit" -->
          <a class="btn" Confirmation (confirmationClick)="cancelTransit()">
            {{ 'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.CANCEL_TRANSIT' | translate}}
          </a>
          <!--a class="btn" Confirmation (confirmationClick)="postponeTransit()">
            {{ 'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.POSTPONE_TRANSIT' | translate}}
          </a>-->
        </li>
      </ul>
    </div>
  </div>
  <div *ngIf="isRequireModificationNotesExist" class="bs-callout bs-callout-info">
    <h4>Required Modifications Notes</h4>
    <p>{{requireModificationNotes}}</p>
  </div>
  <form [formGroup]="transitForm" #transitRequest>
    <div>
      <div class="form-container">
        <h4 class="section-title">{{ 'FRONT_USER.REQUEST_INFORMATION' | translate }}</h4>
      </div>
      <tabset *ngIf="feesRequestId" #TransitTabs>
        <tab heading="{{ 'FRONT_USER.FEES_ESTIMATION_TABS.VESSEL_PARTICULARS' | translate}}">
          <app-fees-estimation-details #feesRequest [FormMode]="formMode"
            (isTabOneValid)="receiveTabOneValidity($event)" [FeesRequestId]="feesRequestId" [TransitTabs]="TransitTabs"
            (FeesEstimateObj)="receiveFeesValue($event)"
            (FeesEstimationValidation)="receiveFeesEstimationValidation($event)">
          </app-fees-estimation-details>
          <!-- <p class="btns-holder text-right">
            <button type="button" class="btn SCAcustomBtn"
              (click)="selectTab(1)">{{ 'FRONT_USER.NEXT' | translate}}</button>
          </p> -->
        </tab>
        <tab [disabled]="!isTabOneValid" heading="{{ 'FRONT_USER.TRANSIT_TABS.TRANSIT_INFO' | translate}}">
          <div class="form-container">
            <div class="form-group">
              <label for="D_FWD">{{ 'FRONT_USER.TRANSIT_REQUEST_FORM.D_FWD' | translate}}</label>
              <span class="red">*</span>
              <input type="text" name="D_FWD" id="D_FWD" class="form-control" formControlName="D_FWD">
              <div *ngIf="formSubmitted || (f.D_FWD?.dirty && f.D_FWD?.errors)" class="red ">
                <div *ngIf="f.D_FWD?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                <div *ngIf="f.D_FWD?.errors?.startsWithSpaceError">
                  {{'FRONT_USER.START_WITH_SPACE' | translate}}
                </div>
                <div *ngIf="f.D_FWD?.errors?.maxlength">
                  {{'FRONT_USER.TEXT_MAX_LENGTH_150_ERROR' | translate}}
                </div>

              </div>

            </div>

            <div class="form-group">
              <label for="D_AFT">{{ 'FRONT_USER.TRANSIT_REQUEST_FORM.D_AFT' | translate}}</label>
              <span class="red">*</span>
              <input type="text" name="D_AFT" id="D_AFT" class="form-control" formControlName="D_AFT">
              <div *ngIf="formSubmitted || (f.D_AFT?.dirty && f.D_AFT?.errors)" class="red ">
                <div *ngIf="f.D_AFT?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                <div *ngIf="f.D_AFT?.errors?.startsWithSpaceError">
                  {{'FRONT_USER.START_WITH_SPACE' | translate}}
                </div>
                <div *ngIf="f.D_AFT?.errors?.maxlength">
                  {{'FRONT_USER.TEXT_MAX_LENGTH_150_ERROR' | translate}}
                </div>

              </div>
            </div>

            <div class="form-group">
              <label for="AirDraught">{{ 'FRONT_USER.TRANSIT_REQUEST_FORM.AIR_DRAUGHT' | translate}}</label>
              <span class="red">*</span>
              <input type="text" name="AirDraught" id="AirDraught" class="form-control" formControlName="AirDraught">
              <div *ngIf="formSubmitted || (f.AirDraught?.dirty && f.AirDraught?.errors)" class="red ">
                <div *ngIf="f.AirDraught?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                <div *ngIf="f.AirDraught?.errors?.startsWithSpaceError">
                  {{'FRONT_USER.START_WITH_SPACE' | translate}}
                </div>
                <div *ngIf="f.AirDraught?.errors?.maxlength">
                  {{'FRONT_USER.TEXT_MAX_LENGTH_150_ERROR' | translate}}
                </div>

              </div>
            </div>

            <div class="form-group">
              <label for="PropellerType">{{ 'FRONT_USER.TRANSIT_REQUEST_FORM.PROPELLER_TYPE' | translate}}</label>
              <span class="red">*</span>
              <textarea type="text" name="PropellerType" id="PropellerType" class="form-control"
                formControlName="PropellerType"> </textarea>

              <div *ngIf="formSubmitted || (f.PropellerType?.dirty && f.PropellerType?.errors)" class="red ">
                <div *ngIf="f.PropellerType?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                <div *ngIf="f.PropellerType?.errors?.startsWithSpaceError">
                  {{'FRONT_USER.START_WITH_SPACE' | translate}}
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="Anchors">{{ 'FRONT_USER.TRANSIT_REQUEST_FORM.ANCHORS' | translate}}</label>
              <span class="red">*</span>
              <textarea type="text" name="Anchors" id="Anchors" class="form-control"
                formControlName="Anchors"> </textarea>
              <div *ngIf="formSubmitted || (f.Anchors?.dirty && f.Anchors?.errors)" class="red ">
                <div *ngIf="f.Anchors?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                <div *ngIf="f.Anchors?.errors?.startsWithSpaceError">
                  {{'FRONT_USER.START_WITH_SPACE' | translate}}
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="ShipsCranes">{{ 'FRONT_USER.TRANSIT_REQUEST_FORM.SHIPS_CRANES' | translate}}</label>
              <span class="red">*</span>
              <textarea type="text" name="ShipsCranes" id="ShipsCranes" class="form-control"
                formControlName="ShipsCranes"></textarea>
              <div *ngIf="formSubmitted || (f.ShipsCranes?.dirty && f.ShipsCranes?.errors)" class="red ">
                <div *ngIf="f.ShipsCranes?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                <div *ngIf="f.ShipsCranes?.errors?.startsWithSpaceError">
                  {{'FRONT_USER.START_WITH_SPACE' | translate}}
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="Class">{{ 'FRONT_USER.TRANSIT_REQUEST_FORM.CLASS' | translate}}</label>
              <span class="red">*</span>
              <input type="text" name="Class" id="Class" class="form-control" formControlName="Class" />
              <div *ngIf="formSubmitted || (f.Class?.dirty && f.Class?.errors)" class="red ">
                <div *ngIf="f.Class?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                <div *ngIf="f.Class?.errors?.startsWithSpaceError">
                  {{'FRONT_USER.START_WITH_SPACE' | translate}}
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="BuildingDate">{{ 'FRONT_USER.TRANSIT_REQUEST_FORM.DATE_OF_BUILDING' | translate}}</label>
              <span class="red">*</span>
              <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker name="BuildingDate"
                id="BuildingDate" formControlName="BuildingDate" [(bsValue)]="bsValue"
                [bsConfig]="{dateInputFormat: 'YYYY', minMode: hour, maxDate: yearBuiltMaxDate}" autocomplete="off"
                [minDate]="null" [maxDate]="todayDate" (onShown)="onOpenYearBuiltCalendar($event)">
              <div *ngIf="formSubmitted || (f.BuildingDate?.dirty && f.BuildingDate?.errors)" class="red ">
                <div *ngIf="f.BuildingDate?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                <div *ngIf="f.BuildingDate?.errors?.inValidDateError">
                  {{'FRONT_USER.DATE_ERROR' | translate}}
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="MaxManouveringSpeed">{{ 'FRONT_USER.TRANSIT_REQUEST_FORM.MAX_MANOUVERING_SPEED' |
                translate}}</label>
              <span class="red">*</span>
              <input type="text" name="MaxManouveringSpeed" id="MaxManouveringSpeed" class="form-control"
                formControlName="MaxManouveringSpeed" />
              <div *ngIf="formSubmitted || (f.MaxManouveringSpeed?.dirty && f.MaxManouveringSpeed?.errors)"
                class="red ">
                <div *ngIf="f.MaxManouveringSpeed?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
                <div *ngIf="f.MaxManouveringSpeed?.errors?.startsWithSpaceError">
                  {{'FRONT_USER.START_WITH_SPACE' | translate}}
                </div>
                <div *ngIf="f.MaxManouveringSpeed?.errors?.maxlength">
                  {{'FRONT_USER.TEXT_MAX_LENGTH_150_ERROR' | translate}}
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="LastName">{{ 'FRONT_USER.TRANSIT_REQUEST_FORM.LAST_NAME' | translate}}</label>
              <input type="text" name="LastName" id="LastName" class="form-control" formControlName="LastName" />
              <div *ngIf="formSubmitted || (f.LastName?.dirty && f.LastName?.errors)" class="red ">
                <div *ngIf="f.LastName?.errors?.startsWithSpaceError">
                  {{'FRONT_USER.START_WITH_SPACE' | translate}}
                </div>
                <div *ngIf="f.LastName?.errors?.maxlength">
                  {{'FRONT_USER.TEXT_MAX_LENGTH_150_ERROR' | translate}}
                </div>

              </div>
            </div>

            <div class="form-group">
              <label for="LastFlagId">{{ 'FRONT_USER.TRANSIT_REQUEST_FORM.LAST_TRANSIT_FLAG' | translate}}</label>
              <select formControlName="LastFlagId" class="form-control">
                <option [value]="''" selected>
                  {{'FRONT_USER.TRANSIT_REQUEST_FORM.CHOOSE_LAST_TRANSIT_FLAG' | translate}}
                </option>
                <ng-container *ngFor="let nationality of nationalities">
                  <option *ngIf="displayedLang==Languages.English" [value]="nationality.Id">
                    {{nationality.NameEN}}
                  </option>
                  <option *ngIf="displayedLang==Languages.Arabic" [value]="nationality.Id">
                    {{nationality.NameAR}}
                  </option>
                </ng-container>

              </select>
            </div>
            <!-- ================================================================================================================== -->
            <div *ngIf="showTransitType" class="form-group">
              <label for="TransitType">
                {{ 'FRONT_USER.TRANSIT_REQUEST_FORM.TRANSIT_TYPE' | translate }}
              </label>
              <span class="red">*</span>

              <div class="form-custom-inputs">

                <!-- 1. The loop goes through all 3 keys: DIRECTTRANSIT, LOADINGUNLOADING, FROMDAMIETTA -->
                <ng-container *ngFor="let type of transitTypeKeys">

                  <!-- 2. THE LOGIC THAT MAKES IT WORK -->
                  <div class="custom-Radio" *ngIf="type !== 'FROMDAMIETTA' || showContainer">
                    <input type="radio" [id]="type" name="TransitType" [value]="transitType[type]"
                      formControlName="TransitType" />
                    <label [for]="type">
                      {{ 'FRONT_USER.TRANSIT_REQUEST_FORM.' + type | translate }}
                    </label>
                  </div>

                </ng-container>

              </div>

              <div *ngIf="formSubmitted || (f.TransitType?.dirty && f.TransitType?.errors)" class="red">
                <div *ngIf="f.TransitType?.errors?.required">
                  {{ 'FRONT_USER.This_Field_Is_Required' | translate }}
                </div>
              </div>
            </div>





            <div class="form-group">
              <label for="IsRadioActive">{{ 'FRONT_USER.TRANSIT_REQUEST_FORM.IS_RADIO_ACTIVE' | translate }}</label>
              <span class="red">*</span>

              <div class="form-custom-inputs">
                <div *ngFor="let radioKey of radioActiveOptionKeys; let i = index" class="custom-Radio">
                  <input type="radio" [id]="'RadioActiveRadio' + i" name="IsRadioActive" [value]="radioKey"
                    formControlName="IsRadioActive" />
                  <label [for]="'RadioActiveRadio' + i">{{ 'FRONT_USER.TRANSIT_REQUEST_FORM.' + radioKey | translate
                    }}</label>
                </div>
              </div>

              <div *ngIf="formSubmitted || (f.IsRadioActive?.dirty && f.IsRadioActive?.errors)" class="red">
                <div *ngIf="f.IsRadioActive?.errors?.required">
                  {{ 'FRONT_USER.This_Field_Is_Required' | translate }}
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="IsCarryingAnimals">{{ 'FRONT_USER.TRANSIT_REQUEST_FORM.IS_CARRYING_ANIMALS' | translate
                }}</label>
              <span class="red">*</span>

              <div class="form-custom-inputs">
                <div *ngFor="let animalKey of carryingAnimalsOptionKeys; let i = index" class="custom-Radio">
                  <input type="radio" [id]="'CarryingAnimalsRadio' + i" name="IsCarryingAnimals" [value]="animalKey"
                    formControlName="IsCarryingAnimals" />
                  <label [for]="'CarryingAnimalsRadio' + i">{{ 'FRONT_USER.TRANSIT_REQUEST_FORM.' + animalKey |
                    translate }}</label>
                </div>
              </div>

              <div *ngIf="formSubmitted || (f.IsCarryingAnimals?.dirty && f.IsCarryingAnimals?.errors)" class="red">
                <div *ngIf="f.IsCarryingAnimals?.errors?.required">
                  {{ 'FRONT_USER.This_Field_Is_Required' | translate }}
                </div>
              </div>
            </div>



            <!-- ================================================================================================================== -->

            <div class="form-group">
              <label for="SecurityLevelId">{{ 'FRONT_USER.TRANSIT_REQUEST_FORM.SECURITY_LEVEL' | translate}}</label>
              <span class="red">*</span>
              <select formControlName="SecurityLevelId" id="SecurityLevelId" name="SecurityLevelId" class="form-control"
                [ngClass]="{ 'is-invalid': formSubmitted || (f.SecurityLevelId?.dirty && f.SecurityLevelId?.errors) }">
                <option [value]="''" selected>
                  {{'FRONT_USER.TRANSIT_REQUEST_FORM.CHOOSE_SECURITY_LEVEL' | translate}}
                </option>
                <ng-container *ngFor="let level of securityLevels">
                  <option *ngIf="displayedLang == Languages.English" [value]="level.Id">
                    {{level.NameEN}}
                  </option>
                  <option *ngIf="displayedLang == Languages.Arabic" [value]="level.Id">
                    {{level.NameAR}}
                  </option>
                </ng-container>
              </select>

              <div *ngIf="formSubmitted || (f.SecurityLevelId?.dirty && f.SecurityLevelId?.errors)" class="red ">
                <div *ngIf="f.SecurityLevelId?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="ExtraFee">{{ 'FRONT_USER.TRANSIT_REQUEST_FORM.EXTRA_FEES' | translate}}</label>
              <span class="red">*</span>

              <div class="input-group">
                <input type="text" name="ExtraFee" id="ExtraFee" class="form-control" formControlName="ExtraFee" />
                <span class="input-group-addon">%</span>
              </div>

              <div *ngIf="formSubmitted || (f.ExtraFee?.dirty && f.ExtraFee?.errors)" class="red ">
                <div *ngIf="f.ExtraFee?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>

                <div *ngIf="f.ExtraFee?.errors?.pattern">{{'FRONT_USER.NUMBER_ERROR' | translate}}</div>
                <div *ngIf="f.ExtraFee?.errors?.startsWithSpaceError">
                  {{'FRONT_USER.START_WITH_SPACE' | translate}}
                </div>
                <div *ngIf="f.ExtraFee?.errors?.maxlength">
                  {{'FRONT_USER.TEXT_MAX_LENGTH_150_ERROR' | translate}}
                </div>

              </div>
            </div>

            <div class="form-group">
              <label for="IMONO">{{ 'FRONT_USER.TRANSIT_REQUEST_FORM.IMO_NO' | translate}}</label>
              <span class="red">*</span>
              <div class="input-group">
                <span class="input-group-addon">IMO</span>
                <input type="text" name="IMONO" id="IMONO" class="form-control" formControlName="IMONO" />
              </div>
              <div *ngIf="formSubmitted || (f.IMONO?.dirty && f.IMONO?.errors)" class="red ">
                <div *ngIf="f.IMONO?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>

                <div *ngIf="f.IMONO?.errors?.pattern">{{'FRONT_USER.IMO_ERROR' | translate}}</div>
                <div *ngIf="f.IMONO?.errors?.startsWithSpaceError">
                  {{'FRONT_USER.START_WITH_SPACE' | translate}}
                </div>

                <div *ngIf="errorIMO.isError" class="red">
                  {{ errorIMO.errorMessage }}
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="Extensions">{{ 'FRONT_USER.TRANSIT_REQUEST_FORM.EXTINTIONS' | translate}}</label>
              <span class="red">*</span>
              <textarea type="text" name="Extensions" id="Extensions" class="form-control"
                formControlName="Extensions"> </textarea>

              <div *ngIf="formSubmitted || (f.Extensions?.dirty && f.Extensions?.errors)" class="red ">
                <div *ngIf="f.Extensions?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                <div *ngIf="f.Extensions?.errors?.startsWithSpaceError">
                  {{'FRONT_USER.START_WITH_SPACE' | translate}}
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="FloatingUnits">{{ 'FRONT_USER.TRANSIT_REQUEST_FORM.FLOATING_UNITS' | translate}}</label>
              <span class="red">*</span>
              <textarea type="text" name="FloatingUnits" id="FloatingUnits" class="form-control"
                formControlName="FloatingUnits"> </textarea>

              <div *ngIf="formSubmitted || (f.FloatingUnits?.dirty && f.FloatingUnits?.errors)" class="red ">
                <div *ngIf="f.FloatingUnits?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                <div *ngIf="f.FloatingUnits?.errors?.startsWithSpaceError">
                  {{'FRONT_USER.START_WITH_SPACE' | translate}}
                </div>
              </div>
            </div>


            <div class="form-group">
              <label for="RegisteryCertificateDate">{{ 'FRONT_USER.TRANSIT_REQUEST_FORM.REGISTERY_CERTIFICATE' |
                translate}}</label>
              <span class="red">*</span>
              <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker name="RegisteryCertificateDate"
                id="RegisteryCertificateDate" formControlName="RegisteryCertificateDate">

              <div *ngIf="formSubmitted || (f.RegisteryCertificateDate?.dirty && f.RegisteryCertificateDate?.errors)"
                class="red ">
                <div *ngIf="f.RegisteryCertificateDate?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                <div *ngIf="f.RegisteryCertificateDate?.errors?.inValidDateError">
                  {{'FRONT_USER.DATE_ERROR' | translate}}
                </div>
              </div>
            </div>
          </div>

          <p class="btns-holder text-right">
            <button type="button" class="btn SCAcustomBtn" (click)="selectTab(0)">{{ 'FRONT_USER.PREVIOUS' |
              translate}}</button>
          </p>

          <div class="bs-callout bs-callout-info  Transit-Antipollution-Alert">
            <h4>{{'FRONT_USER.TRANSIT_REQUEST_FORM.ANTIPOLLUTION_TITLE' | translate}} <span class="red"> *</span></h4>

            <div>
              <label></label>
              <div>
                <div>
                  <!--  <input type="checkbox" id="AntipollutionService" name="AntipollutionService"
                    formControlName="AntipollutionService" />-->
                  <label>

                    {{'FRONT_USER.TRANSIT_REQUEST_FORM.ANTIPOLLUTION_CHECKBOX' | translate}}
                    <a (click)="goToAntipollutionCircular()" target="_blank">
                      {{ 'FRONT_USER.TRANSIT_REQUEST_FORM.ANTIPOLLUTION_CIRCULAR_NO' | translate }}
                    </a>
                  </label>

                </div>
              </div>
              <!-- <div *ngIf="formSubmitted ||(f.AntipollutionService.dirty && f.AntipollutionService?.errors)" class="red ">
                <div *ngIf="f.AntipollutionService?.errors?.required">
                  {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
              </div>-->
            </div>

            <p style="font-weight: bold;">{{'FRONT_USER.TRANSIT_REQUEST_FORM.ANTIPOLLUTION_TEXT' | translate}} <a
                (click)="goToAntipollutionPage()"> {{ 'FRONT_USER.TRANSIT_REQUEST_FORM.ANTIPOLLUTION_LINK_TEXT' |
                translate}} </a></p>
          </div>

        </tab>
      </tabset>
    </div>

    <!-- Updated Condition: Show if Add Mode OR Postpone Mode -->
    <p *ngIf="(formMode == FormMode.Add || isPostponeMode) && validateSubmitButton" class="form-group">
      <!-- Updated Click: Calls submitPostpone if in postpone mode, otherwise onSubmit -->
      <button Confirmation (confirmationClick)="isPostponeMode ? submitPostpone() : onSubmit()"
        class="btn btn-primary SCAcustomBtn">
        <!-- Dynamic Label -->
        <span *ngIf="!isPostponeMode">{{ 'FRONT_USER.SUBMIT' | translate}}</span>
        <span *ngIf="isPostponeMode">{{ 'FRONT_USER.UPDATE' | translate}}</span>

      </button>
    </p>
  </form>


  <div
    *ngIf="sameVesselHasRequest && sameVesselRequestsData.length > 0 && formMode == FormMode.Readonly && loggedInUser?.IsAdmin">
    <div class="form-container">
      <h4 class="section-title">{{'FRONT_USER.FEES_ESTIMATION_FORM.SAME_VESSEL_REQUESTS' | translate }}</h4>
    </div>
    <div class="table-responsive">
      <table class="table table-bordered table-striped table-services">
        <thead>
          <tr>
            <th><span>{{'FRONT_USER.TRANSIT_REQUEST_FORM.REQUEST_NUMBER' | translate }}</span></th>
            <th><span>{{'FRONT_USER.TRANSIT_REQUEST_FORM.AGENT_NAME' | translate }}</span></th>
            <th><span>{{'FRONT_USER.TRANSIT_REQUEST_FORM.TRANSIT_DATE' | translate }}</span></th>
            <th><span>{{'FRONT_USER.TRANSIT_REQUEST_FORM.REQUEST_STATUS' | translate }}</span></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let request of sameVesselRequestsData; let i = index;">
            <td>{{request.RequestNumber}}</td>
            <td>{{request.AgentName}}</td>
            <td>{{request.AgentTransitDate | date:'dd/MM/yyyy'}}</td>
            <td *ngIf="displayedLang==Languages.English">{{request.Status?.StatusEN}}</td>
            <td *ngIf="displayedLang==Languages.Arabic">{{request.Status?.StatusAR}}</td>
            <td><a class="btn" (click)="goToTransitRequestOfSameIMONO(request.Id)">Details</a></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div *ngIf="sameVesselHasTransitDate && formMode == FormMode.Readonly">
    <div class="form-container">
      <h4 class="section-title">{{'FRONT_USER.TRANSIT_REQUEST_FORM.TRANSIT_DATES' | translate }}</h4>
    </div>
    <div class="table-responsive">
      <table class="table table-bordered table-striped table-services">
        <thead>
          <tr>
            <th><span>{{'FRONT_USER.TRANSIT_REQUEST_FORM.PREVIOUS_DATE' | translate }}</span></th>
            <th><span>{{'FRONT_USER.TRANSIT_REQUEST_FORM.REQUESTED_DATE' | translate }}</span></th>
            <th><span>{{'FRONT_USER.TRANSIT_REQUEST_FORM.ACTION_DATE' | translate }}</span></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let request of sameVesselTransitDates; let i = index;">
            <td>{{request.PreviousFieldValue}}</td>
            <td>{{request.FieldValue}}</td>
            <td>{{request.CreationDate | date:'dd/MM/yyyy hh:mm:ss a'}}</td>

          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div *ngIf="!showDesclaimerMessage && !(currentRoute === 'transitRequest' && formMode === FormMode.Add)"
    class="alert alert-danger" role="alert">
    {{ 'FRONT_USER.TRANSIT_REQUEST_FORM.IS_ESTIMATEDFEES_NOT_PAID' | translate }}
  </div>
  <div *ngIf="showDesclaimerMessage" class="alert alert-success" role="alert">
    {{ 'FRONT_USER.TRANSIT_REQUEST_FORM.IS_ESTIMATEDFEES_PAID' | translate }}
  </div>


  <!-- Add Penalties Table -->
  <!-- Add Penalties Table -->
  <div *ngIf="showPenaltiesTable && formMode == FormMode.Readonly">
    <div class="form-container">
      <h4 class="section-title">{{'FRONT_USER.TRANSIT_REQUEST_FORM.PENALTIES' | translate }}</h4>
    </div>
    <div class="table-responsive">
      <table class="table table-bordered table-striped table-services">
        <thead>
          <tr>
            <th><span>{{'FRONT_USER.TRANSIT_REQUEST_FORM.PENALTY_TYPE' | translate }}</span></th>
            <!--<th><span>{{'FRONT_USER.TRANSIT_REQUEST_FORM.PENALTY_VALUE' | translate }}</span></th>-->
            <!--<th><span>{{'FRONT_USER.TRANSIT_REQUEST_FORM.PENALTY_CLAUSE' | translate }}</span></th>-->
            <th><span>{{'FRONT_USER.TRANSIT_REQUEST_FORM.PENALTY_REASON' | translate }}</span></th>
            <th><span>{{'FRONT_USER.TRANSIT_REQUEST_FORM.CREATED_DATE' | translate }}</span></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let penalty of transitPenalties; let i = index;">
            <td>{{ ('FRONT_USER.TRANSIT_REQUEST_FORM.PENALTY_TYPE_' + penalty.PenaltyType) | translate }}</td>
            <!--<td>{{ penalty.PenaltyValue }}</td>-->
            <!--<td>{{ penalty.PenaltyClause }}</td>-->
            <td>{{ ('FRONT_USER.TRANSIT_REQUEST_FORM.' + getPenaltyReasonKey(penalty)) | translate }}</td>
            <td>{{ penalty.CreationDate | date:'dd/MM/yyyy hh:mm:ss a' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- Confirmation -->
<div *ngIf="showRequest && !isErrorMessage && !lockTaskErrorMessage && !lockTaskDoneErrorMessage"
  class="alert alert-success" role="alert">
  <div class="alignC">
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g>
        <g>
          <path
            d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
          </path>
        </g>
      </g>
    </svg>
    <p *ngIf="!showCancel">{{ 'FRONT_USER.SUCCESS_MESSAGE' | translate }}</p>

    <p *ngIf="showCancel">{{ 'FRONT_USER.CANCEL_MESSAGE' | translate }}</p>
    <hr>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
        {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>


  </div>
</div>


<!-- error message -->
<div *ngIf="showRequest && isErrorMessage" class="alert alert-danger" role="alert">
  <div class="alignC">
    <i class="icon-error"></i>

    <p>{{'FRONT_USER.ERRORS_MESSAGES.EROOR_MESSAGE' | translate}}</p>
    <hr>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
        {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
  </div>
</div>

<div *ngIf="showRequest && lockTaskErrorMessage" class="alert alert-warning" role="alert">
  <div class="alignC">
    <i class="icon-error"></i>
    <p>{{'FRONT_USER.ERRORS_MESSAGES.AlreadyHaveTransit' | translate}}</p>
    <hr>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
        {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
  </div>
</div>

<div *ngIf="showRequest && lockTaskDoneErrorMessage" class="alert alert-warning" role="alert">
  <div class="alignC">
    <i class="icon-error"></i>
    <p>{{'FRONT_USER.ERRORS_MESSAGES.LOCK_TASK_ERROR_MESSAGE' | translate}}</p>
    <hr>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
        {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
  </div>
</div>

<app-messaging></app-messaging>